import deepfreeze from 'deep-freeze';

export default deepfreeze({
  APP_VERSION: process.env.REACT_APP_VERSION,
  API_URL_GRAPHQL: process.env.REACT_APP_API_URL_GRAPHQL,
  API_URL: process.env.REACT_APP_API_URL
});
